import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-delete-confirmation-popup',
  templateUrl: './delete-confirmation-popup.component.html',
  styleUrls: ['./delete-confirmation-popup.component.scss'],
})
export class DeleteConfirmationPopupComponent implements OnInit {
  @Input() message: string;
  @Output() onCancel = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  public cancel(): void {
    this.onCancel.emit();
  }

  public delete(): void {
    this.onDelete.emit();
  }
}
